import { useQuery, useQueryClient } from "@tanstack/react-query";

const fetchGeneratedUsername = async () => {
  const response = await fetch('/api/profile/usernameGenerate');
  const data = await response.json();
  return data.username;
};

const useGeneratedUsername = () => {
  const queryClient = useQueryClient();

  const { data: generatedUsername, isLoading, isError } = useQuery({
    queryKey: ['generatedUsername'],
    queryFn: fetchGeneratedUsername,
    staleTime: Infinity, revalidateOnFocus: false 
  });

  const fetchNewUsername = async () => {
    await queryClient.invalidateQueries(['generatedUsername']);
  };

  return { generatedUsername, isLoading, isError, fetchNewUsername };
};

export { useGeneratedUsername, fetchGeneratedUsername };